import { ChangeDetectionStrategy, Component } from '@angular/core';

import { MatDialogModule } from '@angular/material/dialog';

import {
  CcsHelpActionComponent,
  CcsHelpInformationComponent,
  CcsHelpListComponent,
  CcsHelpSupportComponent,
} from './components';

import { CcsHelpResourceService } from './shared/services';

@Component({
  selector: 'app-ccs-help',
  imports: [
    MatDialogModule,
    CcsHelpListComponent,
    CcsHelpActionComponent,
    CcsHelpSupportComponent,
    CcsHelpInformationComponent,
  ],
  template: `
    <mat-dialog-content>
      <section class="flex flex-col gap-2">
        <app-ccs-help-information />
        <app-ccs-help-list />
        <app-ccs-help-support />
      </section>
    </mat-dialog-content>

    <mat-dialog-actions class="flex flex-col md:flex-row gap-7 w-full">
      <app-ccs-help-action />
    </mat-dialog-actions>
  `,
  styleUrls: ['./ccs-help.component.scss'],
  providers: [CcsHelpResourceService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CcsHelpComponent {}
